import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Bingo from './Bingo/Bingo.jsx';
import Plates from './Plates/Plates.jsx';
import PartyFun from './PartyFun/PartyFun.jsx';
import SetasYPorros from './SetasYPorros/SetasYPorros.jsx';

const GameRoom = () => {
    const { gameName } = useParams();

    const gameComponents = {
        'bingo': Bingo,
        'plates': Plates,
        'burrunitos': PartyFun,
        'setasyporros': SetasYPorros,
    };

    const GameComponent = gameComponents[gameName?.toLowerCase()];

    if (!GameComponent) {
        alert('Invalid game name specified.');
        return <Navigate to="/misc/minigames" replace />;
    }

    return <GameComponent />;
};

export default GameRoom;
